import { UserApprovalSettingsModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class AdminSettings extends DomainEntity<UserApprovalSettingsModelDto> {
    public static from(dto: UserApprovalSettingsModelDto): AdminSettings {
        return new AdminSettings(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get id() {
        return this.dto.id;
    }

    public get channelApproveChannel() {
        return this.dto.channelApproveChannel ?? false;
    }

    public set channelApproveChannel(value: boolean) {
        this.dto.channelApproveChannel = value;
    }

    public get channelApproveBackOffice() {
        return this.dto.channelApproveBackOffice ?? false;
    }

    public set channelApproveBackOffice(value: boolean) {
        this.dto.channelApproveBackOffice = value;
    }

    public get backOfficeApproveBackOffice() {
        return this.dto.backOfficeApproveBackOffice ?? false;
    }

    public set backOfficeApproveBackOffice(value: boolean) {
        this.dto.backOfficeApproveBackOffice = value;
    }
}
